import t from "./ghl-ui.es1210.js";
import o from "./ghl-ui.es1211.js";
var r = o(t);
const i = r;
export {
  i as default
};
